import { action } from "mobx";
import { SelectTableViewStore, BaseListViewStore } from "core/stores";
import {
    FacilityOrderTemplateService,
} from "application/facility-order/services";
import _ from "lodash";
import React from "react";
import { toDate } from "core/utils";
import { resolveColumns } from "application/facility-order/util/resolveColumns";
import { uuid } from "core/utils";
import { LookupService } from "common/services";

class FacilityOrderAdjustNextRunDatesViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(
            rootStore.application.baasic.apiClient
        );

        const lookupService = new LookupService(rootStore.application.baasic.apiClient);
        const facilityOrderId = rootStore.routerStore.routerState.params.facilityOrderId;

        super(rootStore, {
            autoInit: true,
            name: "facility-order-adjust-next-run-dates",
            routes:{},
            actions: () => {
                return {
                    find: async (params) => {
                        if (this.counter == 0) {
                            //set default rpp to 50
                            this.counter++;
                            this.queryUtility.filter.reset(500);
                            params = this.queryUtility.plainFilter;
                        }
                        
                        var responseImportDetailStatuses = await lookupService.getLookups('ImportDetailStatus');
                        var newStatus = responseImportDetailStatuses.importDetailStatus.find(x => x.abrv === "new");

                        params = _.extend(params, {
                            embed: "FacilityOrder,ItemCategory,Patient,ImportReference,SubCategory,SubCategory.ItemCategory",
                            facilityOrderId: facilityOrderId,
                            nonCurrent: true,
                            adjustNextRunDate: true,
                            importDetailStatusId: newStatus.id
                        });

                        const response = await facilityOrderTemplateService.find(params);
                        let items = [];
                        _.each(response.data.item, (it) => {
                            let id;
                            let firstName;
                            let lastName;
                            let dateOfBirth;
                            let patientKey;
                            let patientId;
                            let btPatinentId;
                            let subCategory = [];
                            let templateId = [];
                            let ids = [];
                            let inactiveReason = [];
                            let nextRunDate = [];
                            let nextDeliveryDate;
                            let reference = [];
                            let notCurrent = [];
                            let errorMessage = [];
                            id=it.id;
                            patientId = it.patient.id;
                            btPatinentId = it.patient.patientId;
                            patientKey = it.patient.patientKey;
                            firstName = it.patient.firstName;
                            lastName = it.patient.lastName;
                            dateOfBirth = it.patient && toDate(it.patient.dateOfBirth);
                            subCategory = (it.subCategory.abrv == "Formula" || it.subCategory.abrv == "G-Tube" ||
                                it.subCategory.abrv == "Oral-Supplements" || it.subCategory.abrv == "Enteral---Supplies" ||
                                it.subCategory.abrv == "Enteral---Pumps" || it.subCategory.abrv == "Respiratory---trachs-supply" ||
                                it.subCategory.abrv == "Trach-Tube") ? _.concat(it.itemCategory.name + " - " + it.subCategory.name, subCategory) : _.concat(it.subCategory.name, subCategory);
                            templateId = _.concat(it.templateId, templateId);
                            ids = _.concat(it.id, ids);
                            it.inactiveReason = it.inactiveReason == "DoNotSupply" ? "Do Not Supply" : it.inactiveReason;
                            inactiveReason = _.concat(
                                it.inactiveReason,
                                inactiveReason
                            );
                            nextRunDate = _.concat(
                                toDate(it.nextRunDate),
                                nextRunDate
                            );
                            nextDeliveryDate = toDate(it.facilityOrder.nextDeliveryDate)
                            const referenceName = it.importReference && it.importReference.abrv === 'not-found' ? `${it.importReference.abrv},${it.reference}`
                                : it.importReference !== null ? it.importReference.name : "";

                            reference = _.concat(
                                referenceName,
                                reference
                            );
                            notCurrent.push(it.notCurrent);
                            errorMessage.push(it.errorMessage);
                            it.patientId = patientId;
                            it.id = id;
                            it.btPatinentId = btPatinentId;
                            it.patientKey = patientKey;
                            it.firstName = firstName;
                            it.lastName = lastName;
                            it.dateOfBirth = dateOfBirth;
                            it.subCategory = subCategory;
                            it.templateId = templateId;
                            it.ids = ids;
                            it.inactiveReason = inactiveReason;
                            it.nextRunDate = nextRunDate;
                            it.nextDeliveryDate = nextDeliveryDate;
                            it.reference = reference;
                            it.notCurrent = notCurrent;
                            it.errorMessage = errorMessage;
                            items.push({
                                id:it.id,
                                patientId: it.patientId,
                                btPatinentId: it.btPatinentId,
                                patientKey: it.patientKey,
                                patientNumber: it.patientNumber,
                                firstName: it.firstName,
                                lastName: it.lastName,
                                dateOfBirth: it.dateOfBirth,
                                subCategory: it.subCategory,
                                templateId: it.templateId,
                                ids: it.ids,
                                inactiveReason: it.inactiveReason,
                                nextRunDate: it.nextRunDate,
                                nextDeliveryDate: it.nextDeliveryDate,
                                reference: it.reference,
                                notCurrent: it.notCurrent,
                                errorMessage: it.errorMessage
                            });
                        });

                        const responseData = _.extend(response.data, {
                            item: _.map(items, (item) => {
                                return _.extend(item, {
                                    id: item.id,
                                    patientId: item.patientId,
                                    btPatinentId: item.btPatinentId,
                                    patientKey: item.patientKey,
                                    firstName: item.firstName,
                                    lastName: item.lastName,
                                    dateOfBirth: item.dateOfBirth,
                                    subCategory: item.subCategory,
                                    templateId: item.templateId,
                                    ids: item.ids,
                                    nextRunDate: item.nextRunDate,
                                    nextDeliveryDate: item.nextDeliveryDate,
                                    inactiveReason: item.inactiveReason,
                                    reference: item.reference,
                                    isProcessing: item.templateId && item.templateId.every((t) => t === null),
                                    notCurrent: item.notCurrent.reverse(),
                                    errorMessage: item.errorMessage.reverse()
                                });
                            }),
                        });
                        return responseData;
                    },
                    reloadTemplates: async (selectedTemplateItemIds) => {
                        const response = await facilityOrderTemplateService.reloadTemplates(selectedTemplateItemIds);
                        return response;
                    }
                };
            },
        });

        this.service = facilityOrderTemplateService;
        this.brightreeBaseUrl = rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl;
        this.facilityOrderId = facilityOrderId;
        this.setTableStore(
            new SelectTableViewStore(this.queryUtility, {
                columns: resolveColumns([
                    {
                        key: "btPatinentId",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.PATIENT_ID",
                        width: 100
                    },
                    {
                        key: "lastName",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.LAST_NAME",
                        width: 150
                    },
                    {
                        key: "firstName",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.FIRST_NAME",
                        cell: (item) => this.renderFirstNameCell(item),
                        width: 150
                    },
                    {
                        key: "reference",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.REFERENCE",
                        cell: (item) => this.renderReferenceCell(item),
                    },
                    {
                        key: "inactiveReason",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.INACTIVE_REASON",
                        cell: (item) => this.renderInactiveReasonCell(item),
                    },
                    {
                        key: "subCategory",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.SUB_CATEGORY",
                        cell: (item) => this.renderSubCategoryCell(item),
                    },
                    {
                        key: "templateId",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.TEMPLATE_ID",
                        cell: (item) => this.renderTemplateIdCell(item),
                        width: 100
                    },
                    {
                        key: "nextRunDate",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.NEXT_RUN_DATE",
                        cell: (item) => this.renderNextRunDateCell(item),
                        width: 120
                    },
                    {
                        key: "suggestedNextRunDate",
                        title: "FACILITY_ORDER_TEMPLATE.LIST.COLUMNS.SUGGESTED_NEXT_RUN_DATE",
                        cell: (item) => this.renderNextDeliveryDateCell(item)
                    }
                ])
            })
        );
    }

    renderReferenceCell(item) {
        return (
            <td>
                <div className="type--left">
                    {
                        _.zip(
                            item.dataItem.reference,
                            item.dataItem.inactiveReason).map((value) => {
                                const isNotFoundReference = value[0].includes('not-found');
                                const referenceEl = isNotFoundReference ? value[0].split(',')[1] : value[0];
                                const inactiveReason = value[1] == "Hospital" || value[1] == "Expired" || value[1] == "Discharged" || value[1] == "Do Not Supply" || value[1] == "Discontinued";
                                const doNotSupply = value[1] == "Do Not Supply" || value[1] == "" || value[1] == null;
                                const fontStyle = doNotSupply ? "" : "italic";
                                return (
                                    isNotFoundReference ?
                                        (
                                            inactiveReason ?
                                                <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                    <i title='Reference Not Found' className="u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>{referenceEl !== '' ? (referenceEl) : ''}
                                                </div>
                                                :
                                                <div key={uuid()}>
                                                    <i title='Reference Not Found' className="u-icon u-icon--sml u-icon--warning--yellow u-mar--right--tny"></i>{referenceEl !== '' ? (referenceEl) : ''}
                                                </div>
                                        )
                                        :
                                        (
                                            inactiveReason ?
                                                <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                    {referenceEl}
                                                </div> :
                                                <div key={uuid()}>
                                                    {referenceEl}
                                                </div>
                                        )

                                );
                            })}
                </div>
            </td>
        );
    }

    renderTemplateIdCell(item) {
        return (
            <td>
                <div className="type--left">
                    {_.zip(
                        item.dataItem.templateId,
                        item.dataItem.ids,
                        item.dataItem.inactiveReason).map((value) => {
                            const inactiveReason = value[2] == "Hospital" || value[2] == "Expired" || value[2] == "Discharged" || value[2] == "Do Not Supply" || value[2] == "Discontinued";
                            const doNotSupply = value[2] == "Do Not Supply" || value[2] == "" || value[2] == null;
                            const fontStyle = doNotSupply ? "" : "italic";
                            return (
                                value[0] ?
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                <span><a target='_blank' href={`${this.brightreeBaseUrl}OrderEntry/SOTemplateScheduleRO.aspx?SalesOrderTemplateKey=${value[0]}&Edit=0`}>{value[0]}</a></span>
                                            </div>
                                            :
                                            <div key={uuid()}>
                                                <span><a target='_blank' href={`${this.brightreeBaseUrl}OrderEntry/SOTemplateScheduleRO.aspx?SalesOrderTemplateKey=${value[0]}&Edit=0`}>{value[0]}</a></span>
                                            </div>
                                    )
                                    :
                                    (
                                        (value[1] && value[0] != null) || inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>NEW</div>
                                            :
                                            <div key={uuid()}>NEW</div>
                                    )
                            );
                        })
                    }
                </div>
            </td>
        );
    }

    renderSubCategoryCell(item) {
        return (
            <td>
                <div className="type--left">
                    {_.zip(
                        item.dataItem.subCategory,
                        item.dataItem.inactiveReason).map((value) => {
                            const inactiveReason = value[1] == "Hospital" || value[1] == "Expired" || value[1] == "Discharged" || value[1] == "Do Not Supply" || value[1] == "Discontinued";
                            const doNotSupply = value[1] == "Do Not Supply" || value[1] == "" || value[1] == null;
                            const fontStyle = doNotSupply ? "" : "italic";
                            return (
                                value[0] ?
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                {value[0]}
                                            </div>
                                            :
                                            <div key={uuid()}>
                                                {value[0]}
                                            </div>
                                    )
                                    :
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>NEW</div>
                                            :
                                            <div key={uuid()}>NEW</div>
                                    )
                            );
                        })
                    }
                </div>
            </td>
        );
    }

    renderInactiveReasonCell(item) {
        return (
            <td>
                <div className="type--left">
                    {_.zip(
                        item.dataItem.inactiveReason).map((value) => {
                            const inactiveReason = value[0] == "Hospital" || value[0] == "Expired" || value[0] == "Discharged" || value[0] == "Do Not Supply" || value[0] == "Discontinued";
                            const doNotSupply = value[0] == "Do Not Supply" || value[0] == "" || value[0] == null;
                            const fontStyle = doNotSupply ? "" : "italic";
                            return (
                                value[0] ?
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>
                                                {value[0]}
                                            </div>
                                            :
                                            <div key={uuid()}>
                                                {value[0]}
                                            </div>
                                    )
                                    :
                                    (
                                        inactiveReason ?
                                            <div style={{ color: "darkred", fontStyle: fontStyle }} key={uuid()}>NEW</div>
                                            :
                                            <div key={uuid()}>NEW</div>
                                    )
                            );
                        })
                    }
                </div>
            </td>
        );
    }

    renderNextRunDateCell(item) {
        return (
            <td>
                <div className="type--left">
                    {_.zip(
                        item.dataItem.nextRunDate,
                        item.dataItem.notCurrent,
                        item.dataItem.inactiveReason).map((value) => {
                            const inactiveReason = value[2] == "Hospital" || value[2] == "Expired" || value[2] == "Discharged" || value[2] == "Do Not Supply" || value[2] == "Discontinued";
                            const doNotSupply = value[2] == "Do Not Supply" || value[2] == "" || value[2] == null || value[2] == "None";
                            const fontStyle = doNotSupply ? "" : "italic";
                            const color = inactiveReason === true ? "darkred" : "";
                            return (
                                value[0] ?
                                    (
                                        value[1] ?
                                            <div style={{ color: color, fontWeight: "bold" }} key={uuid()}>
                                                {value[0]}
                                            </div>
                                            :
                                            <div style={{ color: color, fontStyle: fontStyle }} key={uuid()}>
                                                {value[0]}
                                            </div>
                                    )
                                    :
                                    (
                                        value[1] ?
                                            <div style={{ fontWeight: "bold" }} key={uuid()}>NEW</div>
                                            :
                                            <div style={{ color: color, fontStyle: fontStyle }} key={uuid()}>NEW</div>
                                    )
                            );
                        })
                    }
                </div>
            </td>
        );
    }

    renderNextDeliveryDateCell(item) {
        return (
            <td>
                <div className="type--left">
                    {item.dataItem.nextDeliveryDate}
                </div>
            </td>
        );
    }

    renderFirstNameCell(item) {
        const firstName = item.dataItem.firstName;
        const isProcessing = item.dataItem.isProcessing;
        return (
            <td>
                <div className="type--left">
                    {firstName}
                    {isProcessing && <i style={{
                        display: "inline-block",
                        marginLeft: "7px",
                        ariaLabel: "Label"
                    }} className="u-icon u-icon--sml u-icon--new-user"></i>
                    }
                </div>
            </td>
        );
    }

    @action.bound
    async reloadTemplates() {
        try {
            await this.actions.reloadTemplates(this.tableStore.selectedItems.map(x => x.id));
            this.queryUtility.fetch();
            this.rootStore.notificationStore.success('Facility order templates successfully reloaded.');
        } 
        catch(err) {
            this.rootStore.notificationStore.error('Error occured while trying to reload templates.');
        }
    }
}

export default FacilityOrderAdjustNextRunDatesViewStore;
